// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

const Companies: React.LazyExoticComponent<any> = React.lazy(() => import('../components/dashboard/Companies'));

export default class Loader extends TabLoader {
  /* Override tab loader method */
  public loadTab = (tabId?: string | number): void => {
    const access: boolean = true;
    if (access) {
      window.store.dispatch(removeAll());

      const tabData: TabConfig = {
        id: String(tabId || window.getStr()),
        active: true,
        title: 'Management | Companies',
        component: Companies,
        props: {
          report: 'MANAGEMENT_COMPAINES',
          title: 'Companies',
        },
      };

      window.store.dispatch(addTab(tabData));
    }
  };
}
